import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { faTrash, faLoader } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TrueImpactFile } from 'shared/design-system/components/TrueImpactFileUploadBox';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const spin = keyframes`
  100% { 
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  } 
`;

const StyledDiv = styled.div<{ imageSrc?: string; isUploading?: boolean }>`
  position: relative;
  width: 100%;
  height: 234px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  ${({ imageSrc }) => `background-image: url(${imageSrc});`}
  .image {
    width: 100%;
    height: 100%;
    max-height: 234px;
  }
  img {
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    display: block;
    max-height: 234px;
  }
  .delete {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      0deg,
      rgba(0, 115, 163, 0.5),
      rgba(0, 115, 163, 0.5)
    );
    ${({ isUploading }) =>
      isUploading ? '' : 'opacity: 0; visibility: hidden;'}
    transition: opacity 1s; visibility 1s;
    .delete-icon {
      cursor: pointer;
      border-radius: 100%;
      padding: ${SPACERS.small} 18px;
      background-color: ${({ isUploading }) =>
        isUploading ? COLORS.ctaPrimary : COLORS.whiteBase};
      svg {
        width: 25px;
        height: 25px;
        ${({ isUploading }) =>
          isUploading
            ? css`
                animation: ${spin} 4s linear infinite;
              `
            : ''}
        path {
          fill: ${({ isUploading }) =>
            isUploading ? COLORS.whiteBase : COLORS.ctaPrimary};
        }
      }
    }
  }
  &:hover .delete {
    opacity: 1;
    visibility: visible;
  }
`;

const StoryFileRender: React.FC<TrueImpactFile & {
  handleFileDelete: () => unknown;
  handleFileUploadClick: () => unknown;
}> = ({ file, url, isUploading, handleFileDelete, handleFileUploadClick }) => {
  if (!isUploading && !file && !url) return null;
  const imageSrc = isUploading ? undefined : url || URL.createObjectURL(file!);
  return (
    <StyledDiv isUploading={isUploading} imageSrc={imageSrc}>
      <div className="delete">
        <div className="delete-icon" onClick={handleFileDelete}>
          <FontAwesomeIcon icon={isUploading ? faLoader : faTrash} />
        </div>
      </div>
    </StyledDiv>
  );
};

export default StoryFileRender;
